import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import BaiduMap from 'vue-baidu-map'

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import 'element-ui/lib/theme-chalk/index.css';

// require('../src/css/base.css');

// import * as qiniu from 'qiniu-js'
import $ from 'jquery'
import { IMAGEPATH,APP_PATH } from '@/utils/url'
Vue.prototype.IMAGEPATH= IMAGEPATH;
Vue.prototype.APP_PATH= APP_PATH;

import { filterDateTime,filterTime,filterDate,filterYearMonth,filterday} from '@/utils/filterTime'
Vue.prototype.filterDateTime= filterDateTime
Vue.prototype.filterTime= filterTime
Vue.prototype.filterDate= filterDate
Vue.prototype.filterYearMonth= filterYearMonth
Vue.prototype.filterday= filterday


// 返回上一步
Vue.prototype.goBack = function () {
  router.go(-1);
};
// 全局注册组件
import { custormAnchor } from '@/utils/custormAnchor' // 滚动锚点
Vue.prototype.custormAnchor= custormAnchor

// import Header from "@/components/Hearder/Header.vue";
// Vue.component('Header', Header);
import Header from "@/components/Hearder/HeaderN.vue";
Vue.component('Header', Header);
import Footer from '@/components/Footer/Footer.vue'
Vue.component('Footer', Footer);

// import OrgFooter from "@/components/Footer/Footer.vue";  //子机构底部
// Vue.component('OrgFooter', OrgFooter);

import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination);  // 分页
import Comment from "@/components/Comment"; // 评论
Vue.component('Comment', Comment);
import IsLogin from "@/components/isLogin"; //是否登录
Vue.component('IsLogin', IsLogin);

import CustomDialog from '@/components/CustomDialog'
Vue.component('CustomDialog', CustomDialog);
import TipDialog from '@/components/Tip'
Vue.component('TipDialog', TipDialog);

import { shareToWeibo } from '@/utils/shareContent' // 分享
Vue.prototype.shareToWeibo= shareToWeibo

import { setStorage,getStorage,removeStorage } from '@/utils/setLocalStorage'
Vue.prototype.$storage= {setStorage,getStorage,removeStorage}

//公用方法
import { clearObj } from '@/utils/validate'
Vue.prototype.$clearObj = clearObj

import { setCookie,getCookie,removeCookie } from '@/utils/setCookie'  // cookie
Vue.prototype.$cookie= {setCookie,getCookie,removeCookie}

// import BaiduMap from 'vue-baidu-map-v3'
// 地图
Vue.use(BaiduMap, {
  ak: 'oW2UEhdth2tRbEE4FUpF9E5YVDCIPYih',
})
// 跳转百度地图
import { openBaiduMap } from '@/utils/openBaiduMap'
Vue.prototype.openBaiduMap= openBaiduMap

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
